import ManualOrderConsigneeDTO from "@/dto/manualOrder/ManualOrderConsigneeDTO";
import { batchRecognizeConsignee } from "@/services/api/manualOrder";
import { ThunderboltFilled } from "@ant-design/icons";
import { useRequest } from "ahooks";
import { Button, message, Modal } from "antd";
import React from "react";

interface RecognizeAddressButtonProps {
    /**待识别的地址 */
    value?: string;

    shopId: number;

    onChange?(value: ManualOrderConsigneeDTO): void;
}

const RecognizeAddressButton: React.FC<RecognizeAddressButtonProps> = function (props) {
    const { shopId, value, onChange } = props;

    const { runAsync, loading } = useRequest(batchRecognizeConsignee, { manual: true });

    async function handleRecognizeAddress() {
        if (!value) {
            return Modal.error({
                title: "请先填写收货人信息",
            });
        }

        const consignees = await runAsync(shopId, [value]);

        message.success("识别完成！如果识别效果不好请手动填写并联系客服反馈");

        onChange?.(consignees[0]);
    }

    return (
        <Button
            loading={loading}
            onClick={handleRecognizeAddress}
            className="mt5 mr5"
            size="small"
            type="primary"
            icon={<ThunderboltFilled />}
        >
            一键识别
        </Button>
    );
};

export default RecognizeAddressButton;
